import { render, staticRenderFns } from "./BasicPageSlider.vue?vue&type=template&id=6c0d1396&scoped=true&"
import script from "./BasicPageSlider.vue?vue&type=script&lang=js&"
export * from "./BasicPageSlider.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageSlider.vue?vue&type=style&index=0&id=6c0d1396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0d1396",
  null
  
)

export default component.exports